/* makeover.js (test theme, 2026-10-07): colour follows the coat.
   - Collection cards: picking a coat swatch moves the card's mat to that coat's tint.
   - Product page: the page background takes the selected coat's tint (from #mk-kit,
     the product's sable.coat_walls metafield written by coat_kit.py). */
(function () {
  'use strict';

  document.addEventListener('click', function (e) {
    var sw = e.target.closest && e.target.closest('.so-swatch[data-mk-tint]');
    if (!sw) return;
    var tint = sw.getAttribute('data-mk-tint');
    var card = sw.closest('[data-so-card]');
    if (tint && card) card.style.setProperty('--mk-tint', tint);
  }, true);

  // Homepage rooms: scrolling down slides the row of full-screen rooms sideways.
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  document.querySelectorAll('.mk-hscroll').forEach(function (sec) {
    var track = sec.querySelector('.mk-hs-track');
    if (!track || reduce) { sec.classList.add('is-static'); return; }
    var ticking = false;
    function place() {
      ticking = false;
      var r = sec.getBoundingClientRect();
      var run = sec.offsetHeight - window.innerHeight;
      var p = run > 0 ? Math.min(1, Math.max(0, -r.top / run)) : 0;
      // Each room HOLDS still for a stretch of scrolling, then glides to the
      // next: the first and last 25% of every step are flat, the middle eases.
      var n = track.children.length, t = p * (n - 1), i = Math.min(n - 2, Math.floor(t)), f = t - i;
      f = Math.min(1, Math.max(0, (f - 0.25) / 0.5)); f = f * f * (3 - 2 * f);
      var step = sec.querySelector('.mk-hs-stage').clientWidth;
      track.style.transform = 'translate3d(' + (-(i + f) * step).toFixed(1) + 'px,0,0)';
    }
    function ask() { if (!ticking) { ticking = true; requestAnimationFrame(place); } }
    window.addEventListener('scroll', ask, { passive: true });
    window.addEventListener('resize', ask);
    place();
  });

  var kitEl = document.getElementById('mk-kit');
  if (!kitEl) return;
  var kit = null;
  try { kit = JSON.parse(kitEl.textContent || 'null'); } catch (err) { kit = null; }
  if (!kit) return;

  function paint() {
    var group = null;
    var groups = document.querySelectorAll('.mw-variant-group[data-option-name]');
    for (var i = 0; i < groups.length; i++) {
      var n = (groups[i].getAttribute('data-option-name') || '').toLowerCase();
      if (n === 'color' || n === 'colour') { group = groups[i]; break; }
    }
    if (!group) return;
    var active = group.querySelector('.mw-variant-btn.is-active');
    var coat = active && active.getAttribute('data-option-value');
    var c = coat && kit[coat];
    if (c && c.tint) document.body.style.setProperty('--mk-tint-page', c.tint);
  }

  paint();
  document.addEventListener('click', function (e) {
    if (e.target.closest && e.target.closest('.mw-variant-btn')) setTimeout(paint, 30);
  });
}());

/* ======================================================================
   MOTION - recipes from transitions.dev (licensed for commercial use).
   Each one checks prefers-reduced-motion and adds nothing if it is set.
   ====================================================================== */
(function () {
  'use strict';
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var EASE = 'cubic-bezier(0.22, 1, 0.36, 1)';

  /* Skeleton reveal: pictures fade in as they land. Ones already loaded show at once. */
  var IMG_SEL = '.mw-frame img, .mk-mat img, .so-room-full img, .mk-hs-photo img';
  function reveal(img) {
    if (img.complete && img.naturalWidth) { img.classList.add('mk-in'); return; }
    var done = function () { img.classList.add('mk-in'); };
    img.addEventListener('load', done, { once: true });
    img.addEventListener('error', done, { once: true });
  }
  document.querySelectorAll(IMG_SEL).forEach(reveal);
  document.documentElement.classList.add('mk-js');
  new MutationObserver(function (muts) {
    muts.forEach(function (m) {
      m.addedNodes.forEach(function (n) {
        if (n.nodeType !== 1) return;
        if (n.matches && n.matches(IMG_SEL)) reveal(n);
        if (n.querySelectorAll) n.querySelectorAll(IMG_SEL).forEach(reveal);
      });
    });
  }).observe(document.body, { childList: true, subtree: true });

  /* Tabs sliding: one pill per button row, moved to whichever button is chosen. */
  function pill(row, buttons, isOn) {
    row.classList.add('mk-has-pill');
    var p = document.createElement('span');
    p.className = 'mk-pill';
    p.setAttribute('aria-hidden', 'true');
    row.insertBefore(p, row.firstChild);
    function move(animate) {
      var on = buttons().filter(isOn)[0];
      if (!on || !on.offsetParent) { p.style.opacity = '0'; return; }
      var snap = !animate || reduce || p.style.opacity !== '1';
      var prev = p.style.transition;
      if (snap) p.style.transition = 'none';
      p.style.transform = 'translate(' + on.offsetLeft + 'px,' + on.offsetTop + 'px)';
      p.style.width = on.offsetWidth + 'px';
      p.style.height = on.offsetHeight + 'px';
      p.style.opacity = '1';
      if (snap) { void p.offsetWidth; p.style.transition = prev; }
    }
    new MutationObserver(function () { move(true); })
      .observe(row, { attributes: true, subtree: true, attributeFilter: ['class', 'aria-pressed', 'hidden'] });
    requestAnimationFrame(function () { move(false); });
    window.addEventListener('resize', function () { move(false); });
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(function () { move(false); });
  }
  document.querySelectorAll('.mw-variant-group[data-option-name]').forEach(function (g) {
    var n = (g.getAttribute('data-option-name') || '').toLowerCase();
    if (n === 'color' || n === 'colour') return;               // swatches keep their own frame
    var row = g.querySelector('.mw-variant-options');
    if (!row) return;
    pill(row, function () { return [].slice.call(row.querySelectorAll('.mw-variant-btn')); },
      function (b) { return b.classList.contains('is-active'); });
  });
  document.querySelectorAll('.so-viewtoggle').forEach(function (row) {
    pill(row, function () { return [].slice.call(row.querySelectorAll('.so-view')); },
      function (b) { return b.getAttribute('aria-pressed') === 'true'; });
  });

  /* Accordion: <details> open and close by height with a blur-in, instead of snapping. */
  document.addEventListener('click', function (e) {
    var sum = e.target.closest && e.target.closest('details > summary');
    if (!sum || reduce) return;
    var d = sum.parentElement;
    if (!d.closest('.salon-page, .mw-product-page, .mw-generic-page')) return;
    e.preventDefault();
    var body = d.querySelector(':scope > .mk-acc-body');
    if (!body) {
      body = document.createElement('div');
      body.className = 'mk-acc-body';
      [].slice.call(d.childNodes).forEach(function (n) { if (n !== sum) body.appendChild(n); });
      d.appendChild(body);
    }
    if (body._anim) { body._anim.cancel(); body._anim = null; }
    if (!d.open || d.classList.contains('mk-closing')) {
      d.classList.remove('mk-closing');
      d.open = true;
      var h = body.scrollHeight;
      body._anim = body.animate(
        [{ height: '0px', opacity: 0, filter: 'blur(2px)' }, { height: h + 'px', opacity: 1, filter: 'blur(0px)' }],
        { duration: 250, easing: EASE });
      body._anim.onfinish = function () { body._anim = null; };
    } else {
      d.classList.add('mk-closing');
      var h2 = body.offsetHeight;
      body._anim = body.animate(
        [{ height: h2 + 'px', opacity: 1, filter: 'blur(0px)' }, { height: '0px', opacity: 0, filter: 'blur(2px)' }],
        { duration: 250, easing: EASE, fill: 'forwards' });
      body._anim.onfinish = function () {
        d.open = false; d.classList.remove('mk-closing');
        if (body._anim) body._anim.cancel();
        body._anim = null;
      };
    }
  });

  /* Number pop-in: when a price changes, its characters roll up one after another. */
  ['product-price', 'btn-price'].forEach(function (id) {
    var el = document.getElementById(id);
    if (!el || reduce) return;
    var last = el.textContent;
    new MutationObserver(function () {
      var txt = el.textContent;
      if (txt === last) return;
      last = txt;
      var wrap = document.createElement('span');
      wrap.className = 'mk-digits';
      txt.split('').forEach(function (ch, i) {
        var s = document.createElement('span');
        s.textContent = ch;
        s.style.setProperty('--i', i);
        wrap.appendChild(s);
      });
      el.replaceChildren(wrap);
      void wrap.offsetHeight;
      wrap.classList.add('is-animating');
    }).observe(el, { childList: true, characterData: true, subtree: true });
  });

  /* Error shake: a field the browser refuses shakes once and goes red for three seconds. */
  document.addEventListener('invalid', function (e) {
    var f = e.target;
    var target = f.type === 'checkbox' ? (f.closest('label') || f.parentElement) : f;
    f.classList.add('mk-err');
    if (!reduce) { target.classList.remove('mk-shaking'); void target.offsetWidth; target.classList.add('mk-shaking'); }
    clearTimeout(f._mkErr);
    f._mkErr = setTimeout(function () { f.classList.remove('mk-err'); target.classList.remove('mk-shaking'); }, 3000);
  }, true);
  document.addEventListener('input', function (e) { if (e.target.classList) e.target.classList.remove('mk-err'); }, true);

  /* Learn-more hover: a small chevron after the "see all" style links. */
  var CHEV = '<span class="mk-chev" aria-hidden="true"><svg viewBox="0 0 16 16"><path class="mk-chev-top" d="M6 4L10 8"/><path class="mk-chev-bot" d="M10 8L6 12"/></svg></span>';
  document.querySelectorAll('.mk-link, .salon-more-head a, .mk-band .mk-btn--line').forEach(function (a) {
    if (!a.querySelector('.mk-chev')) a.insertAdjacentHTML('beforeend', CHEV);
  });
}());
